import LazyLoad from 'vanilla-lazyload';

import Preloader from './app/utils/Preloader';
import ArrayExecutor from './app/utils/ArrayExecutor';
import Navigation from './app/utils/Navigation';
import Home from './app/sections/Home';
import SectionLoader from './app/utils/SectionLoader';
import findAncestor from './app/utils/findAncestor';
import app from './app/global';
import mobileCheck from './app/utils/mobileCheck';

const sections = {
  Home
};

// device detection
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
  document.documentElement.classList.add('mobile');
} else {
  document.documentElement.classList.add('desktop');
}

app.verbose = true;
app.debug = window.location.hash.includes('#debug');
app.site_path = window.site_path;
app.site_url = window.location.origin;
app.wipe = true; // set to false when calling changeSection between projects or capabilities via prev/next button to wait for hide() callback and skip the orange wipe in/out

const arrayExecutor = ArrayExecutor(null, 'Main');
const navigation = Navigation.getInstance();
const sectionLoader = SectionLoader.getInstance();
const preloader = Preloader.getInstance();
preloader.setLoader('LoaderUI');

function handleResize() {
  app.winHeight = window.innerHeight;//rect.height;
  app.winWidth = window.innerWidth;

  if (app.mainMenu) app.mainMenu.resize();
  app.sections[navigation.currentSection.toLowerCase()].resize();
}

function siteIsIn() {
  console.log('SITE IS IN');

  navigation.changeOrder = [
    'section_hide_prev',
    'load',
    'section_shutdown_prev',
    'section_remove_prev',
    'section_add_next',
    'section_init_next',
    'section_startup_next',
    'section_show_next'
  ];

  document.body.classList.add('sitein');

  if (app.mainMenu) app.mainMenu.show();
  if (app.footer && app.footer.show) app.footer.show();

  const imgLoaded = (element) => {
    window.setTimeout(() => {
      findAncestor(element, '.size_wrapper').classList.add('loaded');
    }, 500);
  };

  app.lazyloader = new LazyLoad({
    unobserve_entered: true,
    // callback_enter: showCover,
    callback_loaded: imgLoaded,
    thresholds: '100%'
  });
}

function setupSectionObjects(callback) {
  app.sections = {};
  Object.keys(sections).reduce((o, section) => {
    const obj = o;
    obj[section.toLowerCase()] = sections[section].getInstance();
    sectionLoader.addSection(section, { files: [] });
    return obj;
  }, app.sections);

  if (callback) callback();
}

function setupMenu(callback) {
  console.log('SET UP MENU');

  if (typeof Menu !== 'undefined') {
    app.mainMenu = Menu.getNew();
    app.mainMenu.init();
  }

  callback();
}

function setupFooter(callback) {
  console.log('SET UP FOOTER');

  if (typeof Footer !== 'undefined') {
    app.footer = Footer.getInstance();
    app.footer.init();
  }

  callback();
}

function init() {
  if (mobileCheck.isMobile) document.documentElement.classList.add('mobile');

  setupSectionObjects();

  navigation.currentSection = 'home';
  navigation.forceChange = true;

  navigation.changeOrder = [
    'load',
    'section_add_next',
    'section_init_next',
    'section_startup_next',
    'section_show_next'
  ];

  navigation.loadQueue('main');

  const functionArr = [];

  handleResize();

  Array.prototype.push.apply(functionArr, [
    // { fn: navigation.load, scope: navigation, vars: null },
    { fn: setupMenu, vars: null },
    { fn: setupFooter, vars: null },
    { fn: navigation.changeSection, scope: navigation, vars: [window.location.pathname] },
    { fn: siteIsIn },
  ]);

  arrayExecutor.execute(functionArr);
}

function Main() {
  app.settings = app.settings || {};
  app.sections = {};

  document.documentElement.classList.add('no-touch');

  window.addEventListener('touchstart', function setHasTouch() {
    document.documentElement.classList.remove('no-touch');
    document.documentElement.classList.add('touch');
    if (app.mainMenu && app.mainMenu.setTouch) app.mainMenu.setTouch();
    window.removeEventListener('touchstart', setHasTouch);
  }, false);

  if (mobileCheck.isMobile) {
    // using a settimeout here because it seems like the new width and height is not available right away on orientation change
    window.addEventListener('orientationchange', () => {
      if (app.resizeTimeout) window.clearTimeout(app.resizeTimeout);
      app.resizeTimeout = window.setTimeout(() => handleResize(), 100);
    });
  } else {
    window.addEventListener('resize', handleResize);
  }

  init();
}

Main.prototype.resize = handleResize;

app.main = new Main();

window.addEventListener('beforeunload', () => {
  // window.scroll(0, 0);
  // alert('BEFORE UNLOAD');
});